import React, { createContext, useEffect, useRef, useState } from "react";
import { CostsHeader } from "./components/costsHeader/CostsHeader";
import { CostsTable } from "./components/costsTable/CostsTable";
import { RowsPerPage } from "../../constants/RowsPerPage";
import { useDispatch, useSelector } from "react-redux";
import {
  IComment,
  IExpense,
  IStatistic,
  ISummaryEmployee,
  ITimesheet,
  IUser,
} from "../../models";
import { getBearer } from "../../functions/getBearer";
import axios from "axios";
import { getApiLink } from "../../functions/getApiLink";
import {
  setChosenTimesheet,
  setExpenses,
  setTimesheet,
} from "../../storage/toolkit";
import { CostsStyles } from "./Costs.styles";
import { DownSidebar } from "../../components/downSidebar/DownSidebar";
import { useParams } from "react-router-dom";
import { SetStatistic } from "../../api/SetStatistic";
import { GetAccessToken } from "../../api/GetAccessToken";
import { SetExpenses } from "../../api/SetExpenses";
import { SummaryEmployeesExportTableCosts } from "../summaryEmployees/components/SummaryEmployeesExportTableCosts";

interface ICostsProps {}

export const BlockToEdit: any = createContext(null);
export const BlockToDuplicate: any = createContext(null);
export const FixedTopEdit: any = createContext(null);
export const AmountStatistic: any = createContext(null);

export const Costs: React.FC<ICostsProps> = () => {
  const dispatch = useDispatch();

  const { timesheetId }: any = useParams();

  const user: IUser = useSelector((state: any) => state.toolkit.user);
  const expenseList: IExpense[] = useSelector(
    (state: any) => state.toolkit.expenses
  );
  const chosenTimesheet: ITimesheet = useSelector(
    (state: any) => state.toolkit.chosenTimesheet
  );
  const timesheetStatistic: IStatistic = useSelector(
    (state: any) => state.toolkit.timesheetStatistic
  );
  const summaryEmployees: ISummaryEmployee = useSelector(
    (state: any) => state.toolkit.summaryEmployees
  );

  const [rowsSelectValue, setRowsSelectValue] = useState(RowsPerPage()[3]);
  const [itemToEdit, setItemToEdit] = useState<IExpense>();
  const [itemToDuplicate, setItemToDuplicate] = useState<IExpense>();
  const [isOpenDownSidebar, setIsOpenDownSidebar] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [isWindowMobile, setIsWindowMobile] = useState(false);

  const getExpenses = () => {
    if (!timesheetId && !chosenTimesheet?.id) return;
    getBearer("get");
    axios
      .get(
        getApiLink(
          `/api/timesheet/expenses/?timesheet_id=${
            timesheetId ?? chosenTimesheet.id
          }`
        )
      )
      .then(({ data }) => {
        dispatch(setExpenses(data));
        SetStatistic(dispatch, timesheetId ?? chosenTimesheet.id);
      })
      .catch((er) => {
        er?.response?.status === 401 && GetAccessToken(dispatch, getExpenses);
      });
  };

  useEffect(() => {
    if (timesheetId) {
      window.scrollTo(0, 0);
    }
    if (
      !!timesheetId &&
      chosenTimesheet &&
      !Object.keys(chosenTimesheet).length
    )
      return;

    getExpenses();
  }, [chosenTimesheet, timesheetId]);

  useEffect(() => {
    if (timesheetId) return;
    if (!user?.id) return;

    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    getBearer("get");
    axios
      .get(
        getApiLink(
          `/api/timesheet/expenses/?month=${currentMonth}&year=${currentYear}&user_id=${user.id}`
        )
      )
      .then(({ data }) => {
        dispatch(setExpenses(data));
      })
      .catch(() => {});

    getBearer("get");
    axios
      .get(getApiLink(`/api/timesheet/my/?year=${currentYear}`))
      .then(({ data }) => {
        dispatch(setTimesheet(data));
      })
      .catch(() => {});
  }, [user?.id]);

  useEffect(() => {
    if (summaryEmployees?.all?.length && timesheetId) {
      const chosenTimesheet =
        summaryEmployees.all.filter((item) => item.id === timesheetId)[0] ??
        summaryEmployees.favourite.filter((item) => item.id === timesheetId)[0];

      dispatch(setChosenTimesheet(chosenTimesheet));

      getExpenses();
    }
  }, [summaryEmployees]);

  useEffect(() => {
    if (timesheetId === undefined && chosenTimesheet?.user?.id !== user?.id) {
      // SetTimesheet(dispatch)
      SetExpenses(dispatch, chosenTimesheet.id);
    }

    setIsWindowMobile(window.innerWidth < 576);
  }, []);

  useEffect(() => {
    if (isLoad) return;

    setRowsSelectValue(RowsPerPage()[3]);
    setTimeout(() => {
      setIsLoad(true);
    }, 1000);
  }, [expenseList, isLoad]);

  const [comments, setComments] = useState<IComment[]>([]);

  useEffect(() => {
    if (!chosenTimesheet?.id) return;

    getBearer("get");
    axios
      .get(getApiLink(`/api/comment/?timesheet_id=${chosenTimesheet.id}`))
      .then(({ data }) => {
        setComments(data);
      });
  }, [chosenTimesheet]);

  const [isFixedEditBlock, setIsFixedEditBlock] = useState(false);
  const [amountStatistic, setAmountStatistic] = useState(0);

  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const header = section.querySelector('.section-table__header');
    if (!header) return;
    const observer = new ResizeObserver(() => {
      section.style.setProperty('--sticky-table-head-top', `${header.getBoundingClientRect().height}px`);
    });
    observer.observe(header);
    return () => observer.disconnect();
  }, []);

  return (
    <BlockToDuplicate.Provider value={setItemToDuplicate}>
      <AmountStatistic.Provider value={setAmountStatistic}>
        <FixedTopEdit.Provider value={setIsFixedEditBlock}>
          <BlockToEdit.Provider value={setItemToEdit}>
            <CostsStyles ref={sectionRef}
              style={{
                paddingBottom: isOpenDownSidebar
                  ? "270px"
                  : isWindowMobile
                  ? "60px"
                  : "80px",
              }}
              className={`section-table ${
                isFixedEditBlock && "fixed-edit-block"
              }`}
            >
              <CostsHeader
                itemToDuplicate={itemToDuplicate}
                setItemToDuplicate={setItemToDuplicate}
                isFixedEditBlock={isFixedEditBlock}
                itemToEdit={itemToEdit}
              />
              {chosenTimesheet?.id && (
                <CostsTable
                  itemToEdit={itemToEdit}
                  rowsSelectValue={rowsSelectValue}
                />
              )}

            </CostsStyles>

            <SummaryEmployeesExportTableCosts statisticForTable={expenseList} isOpen={true}/>

            <DownSidebar
              comments={comments}
              amountStatistic={amountStatistic}
              setComments={setComments}
              type={"cost"}
              statisticAllAmount={timesheetStatistic.all_sum}
              statisticAllElements={timesheetStatistic.expenses}
              setIsOpenDownSidebar={setIsOpenDownSidebar}
            />
          </BlockToEdit.Provider>
        </FixedTopEdit.Provider>
      </AmountStatistic.Provider>
    </BlockToDuplicate.Provider>
  );
};
